<template>
  <div class="container" v-if="visible">
    <div class="banner-container">
      <img :src="posterDetail.bgImgTitle" />
    </div>
    <div class="video-container" v-if="posterDetail.enableUlVideo === 1">
      <d-player :url="posterDetail.videoUrl" />
    </div>
    <div v-if="posterDetail.withRetention" class="save-info-container">
      <save-info
        @appointment="handleAppointment"
        :background-image="posterDetail.bgImgPre"
        :acti-large-post-id="posterDetail.id"
        :type="posterDetail.relType"
        :activity-source="posterDetail.actiName"
      />
    </div>
    <div class="lottery-container">
      <lottery
        :phone="phone"
        :user-name="name"
        :appType="appType"
        :title-image="posterDetail.bttTitleImg"
        :background-image="posterDetail.bttBgImg"
        :list="lotteryDetail.labg"
        :actiBigturntableId="lotteryDetail.id"
        :enableBtt="posterDetail.enableBtt"
        :acti-large-post-id="posterDetail.id"
      />
    </div>
    <div
      class="banner-container"
      :class="posterDetail.redirectImgPosition ? '' : 'padding-container'"
    >
      <img :src="posterDetail.bgBgImg" />
    </div>
    <div
      v-if="posterDetail.redirectImgUrl"
      :class="posterDetail.redirectImgPosition ? 'box-float' : 'box-footer'"
      @click="entryAdvert(posterDetail.redirectUrl)"
    >
      <img :src="posterDetail.redirectImgUrl" class="advert-img" />
    </div>
    <van-dialog
      v-model="isShowDialog"
      @confirm="onConfirm"
      :title="activityFilter(activityState)"
    >
    </van-dialog>
  </div>
</template>

<script>
import SaveInfo from '@/components/SaveInfo.vue'
import Lottery from '@/components/Lottery.vue'
import DPlayer from '@/components/DPlayer.vue'
import { getPosterConfig, getWxConfig } from '@/api'
import { Dialog } from 'vant'
import { initWx } from '@/utils/jssdk'

export default {
  name: 'index',
  components: { SaveInfo, Lottery, DPlayer },
  data() {
    return {
      isShowDialog: false,
      activityState: '', // 当前活动的状态
      phone: '',
      name: '',
      appType: '',
      posterDetail: {
        bgImgTitle: '',
        enableUlVideo: 0,
        videoUrl: '',
        bgImgPre: '',
        enableBtt: 1,
        bttTitleImg: '',
        withRetention: 1
      },
      lotteryDetail: {},
      visible: true
    }
  },
  created() {
    const { id } = this.$route.query
    if (id) {
      getPosterConfig({ id })
        .then((res) => {
          this.posterDetail = res.data
          this.lotteryDetail = res.data.actiBigturntableDetailVO
          this.setBrowserTitle(res.data)
          this.setShareMeta({
            title: res.data.shareTitle,
            desc: res.data.shareDoc,
            link: window.location.href,
            imgUrl: res.data.actThumbnail
          })
          if (res.data.actiState && res.data.actiState !== 'GOING') {
            this.activityState = res.data.actiState
            this.isShowDialog = true
          }
        })
        .then(() => getWxConfig({ url: window.location.href.split('#')[0] }))
        .then((res) => initWx(res.data))
        .then(() => {
          // eslint-disable-next-line no-undef
          wx.ready(() => {
            const content = {
              title: this.posterDetail.shareTitle,
              desc: this.posterDetail.shareDoc,
              link: window.location.href,
              imgUrl: this.posterDetail.actThumbnail,
              success: () => {}
            }
            // eslint-disable-next-line no-undef
            wx.updateTimelineShareData(content)
            // eslint-disable-next-line no-undef
            wx.updateAppMessageShareData(content)
          })
        })
        .catch((err) => {
          console.error(err.message)
        })
    } else {
      Dialog.alert({
        title: '警告',
        message: '需要活动id'
      }).then(() => {
        this.visible = false
      })
    }
  },
  methods: {
    isApp() {
      return Boolean(
        window.uni
          || window.Android
          || (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.sharePost)
      )
    },
    isWeixin() {
      const ua = navigator.userAgent.toLowerCase()
      return /micromessenger/i.test(ua)
    },
    setBrowserTitle(detail) {
      if (this.isApp() || !detail || !detail.shareTitle) {
        return
      }
      // 统一用 shareTitle 做页面标题
      document.title = detail.shareTitle
    },
    setShareMeta({
 title, desc, link, imgUrl
}) {
      const description = desc || title
      console.log('设置分享信息', desc)
      this.setMetaContent('name', 'description', description)
      this.setMetaContent('property', 'og:title', title)
      this.setMetaContent('property', 'og:description', description)
      this.setMetaContent('property', 'og:url', link)
      this.setMetaContent('property', 'og:image', imgUrl)
      this.setMetaContent('name', 'twitter:title', title)
      this.setMetaContent('name', 'twitter:description', description)
      this.setMetaContent('name', 'twitter:image', imgUrl)
    },
    setMetaContent(attrName, attrValue, content) {
      if (!content) {
        return
      }
      let meta = document.head.querySelector(
        `meta[${attrName}="${attrValue}"]`
      )
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute(attrName, attrValue)
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', content)
    },
    activityFilter(state) {
      if (state === 'SHUT_DN') {
        return '活动已关闭'
      }
      if (state === 'END') {
        return '活动已结束'
      }
      if (state === 'NOT_ST') {
        return '活动未开始'
      }
      return '活动已关闭'
    },
    // 弹窗确认回调函数
    onConfirm() {
      this.isShowDialog = false
      // 跳转回首页index
      // 判断是否在uni-app环境中
      if (window.uni && typeof window.uni.navigateBack === 'function') {
        // 在uni-app环境中，返回上一页
        window.uni.navigateBack()
      } else if (window.history && window.history.length > 1) {
        // 在普通H5环境中，使用浏览器返回
        window.history.back()
      } else {
        // 备用方案：跳转到首页
        this.$router.push('/pages/home/index')
      }
    },
    handleAppointment(val) {
      const { phone, name } = val
      this.phone = phone
      this.name = name
    },
    entryAdvert(redirectUrl) {
      if (redirectUrl) {
        window.location.href = redirectUrl
      }
    }
  }
}
</script>

<style scoped lang="scss">
img {
  display: block;
  width: 100%;
}
.padding-container {
  // padding-bottom: rem(120);
  padding-bottom: 0;
}
.box-float {
  position: fixed;
  top: 50%;
  right: rem(10);
  width: rem(120);
  height: rem(120);
  margin-top: rem(-60);
  .advert-img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
}
.box-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: rem(120);
  .advert-img {
    width: 100%;
    height: 100%;
  }
}
</style>
